import { useSearchParams } from '@uhg-abyss/web/tools/reactRouterTools';
import { useEffect } from 'react';
import { useShallow } from 'zustand/react/shallow';

import { SearchResultsV2 } from '../../frontends/ProviderSearch/routes/SearchResults';
import { useChipStore } from '../../store/useChipStore';
import { ChipState } from '../../store/useChipStore/chipStore';
import { usePCPStore } from '../../store/usePCPStore';
import { PCPSearchStore } from '../../store/usePCPStore/pcpStore';
import { useTypeaheadStore } from '../../store/useTypeaheadStore';
import { TypeaheadState } from '../../store/useTypeaheadStore/typeaheadStore';
import { doChoosePCPStoreUpdate } from '../../utils/primaryCare.utils';

export const GuestSearchResults = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const chipStore = useChipStore(useShallow((state: ChipState) => state));
  const { setTypeaheadSearchStore } = useTypeaheadStore(
    useShallow((state: TypeaheadState) => ({
      setTypeaheadSearchStore: state.setTypeaheadSearchStore,
      clearTypeaheadSearchStore: state.clearTypeaheadSearchStore,
    }))
  );

  const { setPCPSearchState } = usePCPStore(
    useShallow((state: PCPSearchStore) => ({
      setPCPSearchState: state.setPCPSearchState,
      clearPCPSearchState: state.clearPCPSearchState,
    }))
  );

  useEffect(() => {
    const hasSearchInParams = searchParams.has('search');
    if (!hasSearchInParams) {
      // set search params only if 'search' is not present indicating a new search
      // This will help in avoiding unnecessary updates to the search params
      const depNumber = undefined;

      const urlParams = doChoosePCPStoreUpdate(
        depNumber,
        chipStore ?? 0,
        setTypeaheadSearchStore ?? 0,
        setPCPSearchState ?? 0
      );
      setSearchParams(urlParams);
    }
  }, []);

  return <SearchResultsV2 />;
};
